export default "__VITE_ASSET__akXZPf3V__"